export default {
	firstname: "Vorname",
	lastname: "Nachname",
	phone: "Telefonnummer",
	language: "Sprache",
	languageHint:
		"Dies ist die Sprache der Benutzeroberfläche, nicht die Korrespondenzsprache. Die Korrespondenzsprache für Dokumente und E-Mails legen Sie in den Kundeneinstellungen fest.",
	newsletterSubscribe: "Newsletter abonnieren",
	newsletterSubscribed:
		"Newsletter abonniert. Falls gewünscht, können Sie den Newsletter beim nächsten Versand wieder abbestellen.",
	usernameEmail: "Benutzername / E-Mail",
	changeUsernameTooltip:
		"Klicken Sie hier, um die E-Mail Adresse / den Benutzernamen zu ändern. Sie legen den neuen Benutzernamen in einer Dialogbox fest.",
	changePasswordButton: "Passwort ändern",
	changePasswordTooltip: "Klicken Sie hier, um ihr Passwort zu ändern.",
	appCodeLabel: "App Code für Fusion 360 / SolidWorks Add-In",
	appCodeDescription:
		"Wenn Sie mit Autodesk Fusion 360 oder SolidWorks konstruieren, empfehlen wir die Nutzung des Blexon Add-In. Installieren Sie das AddIn für {fusion} bzw. {solidworks} und verbinden Sie es mit dem obenstehenden App Code mit dem Blexon Shop. Damit können Sie Ihre CAD Modelle ohne Export / Import direkt in den Blexon Shop laden.",
	appCodeSecrecy:
		"Halten Sie Ihren App Code geheim und geben Sie ihn auf keinen Fall an Dritte weiter. Falls Sie den App Code zugänglich gemacht haben, generieren Sie unbedingt einen neuen Code.",
	copyAppCode: "Kopieren",
	copyAppCodeTooltip: "Code in Zwischenablage kopieren",
	regenerateAppCode: "Neu Generieren",
	regenerateAppCodeTooltip:
		"Klicken Sie hier, um einen neuen Code zu generieren. Der Zugriff mit dem alten Code ist dann ab sofort nicht mehr möglich.",
	changeUsernameDialog: {
		title: "Ändern des Benutzernamens",
		text: "Ihre E-Mail Adresse ist gleichzeitig auch ihr Benutzername bei der Anmeldung.",
		text2: "Wenn Sie ihre E-Mail Adresse ändern, ändert sich auch ihr Benutzername. Bitte beachten Sie das bei Ihrer nächsten Anmeldung.",
		newUsernameLabel: "Neuer Benutzername / E-Mail",
		hint: "Hinweis:",
		hintText:
			"Das ist nicht die E-Mail Adresse für den Rechnungsversand. Diese finden Sie in den Einstellungen zur Rechnungsadresse.",
	},
	emailChangeRegisteredDialog: {
		title: "Bestätigungsemail versendet",
		text: "Zur Bestätigung erhalten Sie eine E-Mail an die angegebene neue Adresse.",
		text2: "Mit einem Klick auf den darin enthaltenen Link wird die Änderung aktiv.",
	},
	emailChangeFailedDialog: {
		title: "Änderung Fehlgeschlagen",
		text: "Die Änderung konnte nicht durchgeführt werden.",
		text2: "Bitte kontrollieren Sie, ob die E-Mail Adresse korrekt und gültig ist.",
		text3: "Vielleicht besteht bereits ein Blexonkonto unter dieser E-Mail Adresse.",
		text4: "Wenn Sie der Meinung sind, die neue E-Mail Adresse ist gültig und gehört Ihnen, kontaktieren Sie bitte unser Helpdesk.",
	},
	changePasswordDialog: {
		title: "Passwort ändern",
		text: "Wir senden Ihnen eine E-Mail an {username}. Diese enthält einen Code und einen Link auf die Seite, auf der Sie mit dem Code ein neues Passwort festlegen können.",
		text2: "Bitte überprüfen Sie ebenfalls den Spam-Ordner, falls Sie die E-Mail nicht erhalten.",
	},
	messages: {
		usernameSame:
			"Der neue Benutzername ist identisch zum jetzigen oder zum bereits geänderten Benutzernamen.",
		saveSuccess: "Einstellungen erfolgreich gespeichert.",
		saveError: "Einstellungen konnten nicht gespeichert werden.",
		passwordChangeMailSent: "E-Mail zur Passwortänderung wurde versendet.",
		passwordChangeMailError: "E-Mail zur Passwortänderung konnte nicht versendet werden.",
		appCodeCopied: "App Code erfolgreich in Zwischenablage gespeichert.",
		appCodeGenerateError: "Fehler beim Generieren des App Code. Bitte melden Sie sich bei unserem Helpdesk.",
	},
};
